import React, {useContext, useEffect} from 'react'
import {Carcontext} from "../context/carcontext";
import {useDispatch, useSelector} from "react-redux";
import {fetchExtendedOrder, getDocumentFromServer, showAlert} from "../redux/actions";
import {SET_ORDER_LINK} from "../redux/types";
import {useTranslation} from "react-i18next";
import Aos from 'aos'

const Orders = ({order, clientId}) => {

    const {t} = useTranslation()
    const {openOrderModal, theme} = useContext(Carcontext)
    const dispatch = useDispatch()
    const orderLink = useSelector(state => state.orders.orderLink)

    useEffect(() => {
        Aos.init({
            offset: 50
        })
    }, [])

    function documentDownload(event, orderId, extended) {
        // prevent opening modalBox
        event.stopPropagation()
        dispatch(getDocumentFromServer(orderId, extended))
        dispatch(showAlert('You download will start soon', 'info'))
    }

    function openOrder(order) {
        if (order.is_extended) {
            dispatch(fetchExtendedOrder(order.order_id))
        }
        openOrderModal(order)
    }

    if (orderLink) {
        let linkForDoc = document.createElement('a')
        linkForDoc.setAttribute('href', `https://rezilizer.ru/${orderLink}`)
        linkForDoc.setAttribute('download', "download")
        linkForDoc.click()
        dispatch({type: SET_ORDER_LINK, payload: null})
    }

    return (
        <div data-aos="zoom-out-right" className={`order-item ${theme} ${(() => {
            if (order.client_id === clientId) {
                return 'owns'
            }
        }) ()}`} onClick={() => openOrder(order)}>
            <h4 className="order-id">{order.order_id}.</h4>
            <h3 className="order-client">{order.firstname} {order.lastname}</h3>
            <span className="order-passport-number">{order.passport}</span>
            <span className="order-days">
                {new Date(order.start).toDateString()} - {new Date(order.end).toDateString()}<br/>
                {!!order.is_extended && `${t('extendedTo')}: ${new Date(order.extended_to).toDateString()}`}
            </span>
            <div className="order-car-info">
                <div className="order-car-number">{order.brand}</div>
                <div className="order-car-name">{order.model}</div>
            </div>
            <button onClick={event => documentDownload(event, order.order_id)} className={`order-button ${theme}`}>{t('download')}</button>
        </div>
    )
}

export default Orders
